import React from 'react';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
import image from '../../../Assets/Backgrounds/ebooksBanner.webp';
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        backgroundImage={image}
        title="Free eBooks Library"
        desc="A collection of online guides and downloadable assets, eBooks and customer stories for you to carry with you."
        />
        </>
    )
};
export default Banner ;